import { StyledTabs } from './styled';

export default StyledTabs;